import React from 'react';
import { reduxForm } from 'redux-form/immutable';

import { FormattedMessage } from 'react-intl';
import messages from '../messages';

import Spinner from 'Lib/spinner';

import SmsForm from '../forms/sms-check';
import MainForm from '../forms/main';
import SubmittedView from '../submitted';
import _PreliminaryForm from '../forms/preliminary-form';
import getInitialUserData from '../utils';
import { API_BASE_URL } from 'Common/constants';
import { Api } from '../api';
import { toast, ToastContainer } from 'react-toast';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import makeSelectData from '../selectors';

export const captchaPath = process.env.NODE_ENV === 'development' ? 'http://neww.pm.track.uz' : API_BASE_URL;

class MainFormManager extends React.Component {
  constructor(props) {
    super(props);
    const { formConfig } = this.props;
    this.scrollToForm = React.createRef();
    this.state = {
      loading: false,
      submitted: false,
      hasErrors: false,
      validation: null,
      errorMessage: <FormattedMessage {...messages.unknownError} />,
      result: {},
      isJuridicalChecked: (window.user && window.user.recipient_type_id === 'checked') || false,
      smsChecking: false,
      smsCheckingDone: false,
      showSmsModal: false,
      done: false,
      isAuthorized: !!window.user,
      isAuthByGcp: false,
      action: '',
      formData: undefined,
      phone: undefined,
      captchaUrl: `${captchaPath}/site/captcha`,
      draftId: undefined,
      initialValues: formConfig.initialValues || getInitialUserData(formConfig.formName),
    };
    this.form = reduxForm({
      ...formConfig,
      enableReinitialize: true,
      initialValues: this.state.initialValues,
    })(MainForm);
    this.preliminaryForm = reduxForm({
      form: 'preliminary_form',
      destroyOnUnmount: false,
      initialValues: { document_type: 'passport' },
    })(_PreliminaryForm);
  }
  componentDidMount() {
    if (!!window.user) {
      this.getDraft();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isAuthorized !== this.state.isAuthorized && !!window.user) {
      this.getDraft();
    }
  }

  getDraft = () => {
    const { formType, formName, authorityId } = this.props.formConfig;
    const filterConfig = {
      pin_fl: window.user.pin_fl,
      form_type: formType,
      authority_id: authorityId,
    };
    Api.fetchGetDraft(filterConfig).then((res) => {
      const { body } = res;
      if (body.status) {
        this.setState({
          initialValues: getInitialUserData(formName, body.result),
          draftId: body.result.id,
          isJuridicalChecked: body.result.is_juridical,
          action: 'get-draft',
        });
      } else {
        this.setState({ draftId: undefined, action: 'no-draft' });
      }
    });
  };

  handleSubmit = (formData) => {
    this.setState({ formData: formData, smsChecking: true, smsCheckingDone: false, loading: true });
    this.executeScrollToForm();

    const { formType, authorityId } = this.props.formConfig;
    const jsonFormData = this.prepareFormData(formData);
    jsonFormData['authority_id'] = authorityId;
    if (!jsonFormData['is_juridical']) {
      jsonFormData['juridical_name'] = null;
    }
    if (formType === 5) {
      jsonFormData['persecution_authority_name'] = jsonFormData['authority'];
      jsonFormData['persecution_request_no'] = jsonFormData['request_no'];
      jsonFormData['request_no'] = null;
    }

    console.log('jsonFormData', jsonFormData);

    Api.fetchSendDraft(jsonFormData, this.state.draftId)
      .then(({ body }) => {
        if (
          body.hasOwnProperty('success') &&
          !body.success &&
          body.hasOwnProperty('message') &&
          typeof body.message === 'object'
        ) {
          return Object.values(body.message).forEach((err) => this.renderToast(err[0]));
        }

        if (!body.hasOwnProperty('status')) {
          this.setState({ draftId: body.id });
          return this.makeSmsConfirmation();
        }

        if (body.status) {
          // reset user data after submiting appeal
          if (window.isAuthByGcp) {
            this.updateCaptcha();
            window.user = null;
            window.isAuthByGcp = false;
            this.setState({
              initialValues: null,
              isAuthorized: false,
            });
          }

          this.setState({
            hasErrors: false,
            done: true,
            smsChecking: false,
            result: { ...body, status: !body.status },
          });
        } else {
          this.renderToast(body.message);
        }
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  sendDraft = async () => {
    if (!this.state.draftId) {
      const {
        appState,
        prepareFormDataCb,
        formConfig: { form, formName, formType, authorityId },
      } = this.props;

      const formValues = JSON.parse(JSON.stringify(appState[form].values[formName]));
      formValues._csrf = window._csrf;
      formValues.form_type = formType;
      formValues.draft_id = this.state.draftId;
      formValues.phone = this.state.phone || window.user.phone;
      formValues.birthday = window.user.birthday;
      formValues.authority_id = authorityId;
      formValues.draft_file_validate = true;
      if (!formValues.description) {
        formValues.description = '';
      }

      let mahalla = formValues.mahalla_id;
      if (typeof mahalla === 'object') {
        formValues.mahalla_id = mahalla.value;
      } else {
        formValues.mahalla_id = mahalla;
      }

      prepareFormDataCb(formValues);

      console.log(formValues);

      const { body } = await Api.fetchSendDraft(formValues);

      if (
        body.hasOwnProperty('success') &&
        !body.success &&
        body.hasOwnProperty('message') &&
        typeof body.message === 'object'
      ) {
        return Object.values(body.message).forEach((err) => this.renderToast(err[0]));
      }

      if (!body.hasOwnProperty('status')) {
        this.setState({
          initialValues: getInitialUserData(formName, body),
          draftId: body.id,
        });

        return body.id;
      }

      if (!body.status) {
        this.renderToast(body.message);
      }
    }
  };

  handleSmsSubmit = (phone) => {
    this.setState({ phone: phone, smsChecking: false, smsCheckingDone: true });
    this.submit();
  };

  makeSmsConfirmation = () => {
    if (!this.state.smsCheckingDone) return this.setState({ smsChecking: true, showSmsModal: true });
    // return this.submit();
  };

  prepareFormData = (data) => {
    const {
      formConfig: { formType, formName, authorityId },
      prepareFormDataCb,
    } = this.props;
    const formData = data.toJS();
    formData[formName]._csrf = window._csrf;
    formData[formName].lang = window.LANG;
    formData[formName].form_type = formType;
    formData[formName].draft_id = this.state.draftId;
    formData[formName].phone = this.state.phone || window.user.phone;
    formData[formName].birthday = window.user.birthday;
    formData[formName].authority_id = authorityId;
    let mahalla = formData[formName].mahalla_id;
    if (mahalla instanceof Object) {
      formData[formName].mahalla_id = mahalla.value;
    } else {
      formData[formName].mahalla_id = mahalla;
    }

    return prepareFormDataCb(formData[formName]);
  };

  handleServerError = () =>
    this.setState({
      submitted: true,
      hasErrors: true,
      loading: false,
    });

  submit = () => {
    this.executeScrollToForm();
    const { apiSubmitPromise, apiResponseOkHandleCb, apiResponseErrorHandleCb } = this.props;
    const formData = this.prepareFormData(this.state.formData);
    formData.is_juridical = String(formData.is_juridical);
    (formData.is_agree_electronically =
      formData.is_agree_electronically === 'true' || formData.is_agree_electronically === true ? true : false),
      this.setState({ loading: true });
    // api submit promise must conform the signature
    // func (formData, errorHandlerCb)
    apiSubmitPromise(formData, this.handleServerError).then((resp) => {
      // api response must conform the belove structure
      // {status: Boolean, error: String, result: {request_id, token}}
      const respBody = resp.body;
      if (resp.ok && respBody.status) {
        this.setState({
          draftId: undefined,
          submitted: true,
          done: true,
          loading: false,
          result: { ...resp.body.result, status: resp.body.status },
        });
        apiResponseOkHandleCb(resp);
      } else {
        this.renderToast(resp.body.error || <FormattedMessage {...messages.formError} />);
        Object.values(resp.body.errors).forEach((msg) => {
          this.renderToast(msg);
        });
        this.setState({
          submitted: true,
          hasErrors: true,
          errorMessage: resp.body.error,
          loading: false,
        });
        apiResponseErrorHandleCb(resp);
      }
      if (window.isAuthByGcp) {
        this.updateCaptcha();
        window.user = null;
        window.isAuthByGcp = false;
        this.setState({
          initialValues: null,
          isAuthorized: false,
        });
      }
    });
  };

  handleSubmitPreliminaryForm = (formValues) => {
    this.setState({ loading: true });
    const data = formValues.toJS();

    if (data.document_type === 'passport') {
      data.person_passport_seria = data.person_passport_seria.toUpperCase();
      data.is_consent = 1;
    } else {
      data.cert_series = data.number ? data.number + data.cert_series.toUpperCase() : data.cert_series.toUpperCase();
      delete data.number;
    }
    Api.sendUserData(data)
      .then((resp) => {
        if (resp.ok && resp.body.status) {
          window.user = resp.body.result;
          window.isAuthByGcp = true;
          this.setState({
            initialValues: getInitialUserData(this.props.formConfig.formName),
            isAuthorized: true,
            loading: false,
            hasErrors: false,
            action: data.document_type,
          });
        } else {
          let validation = resp.body.validation && Object.values(resp.body.validation);
          if (validation) {
            validation.forEach((err) => this.renderToast(err[0]));
          } else {
            this.renderToast(resp.body.message);
          }

          this.setState({
            submitted: true,
            hasErrors: true,
            errorMessage: resp.body.message,
            validation,
            loading: false,
            action: data.document_type,
          });
          this.updateCaptcha();
        }
      })
      .catch((err) => {
        if (err.status === 422) {
          err.response.body.forEach((e) => {
            this.renderToast(e.message);
          });
        } else {
          this.renderToast(err.message);
        }

        this.setState({
          submitted: true,
          hasErrors: true,
          errorMessage: 'error',
          loading: false,
          action: data.document_type,
        });
        this.updateCaptcha();
      });
  };

  updateCaptcha = () => {
    Api.fetchCaptcha().then((res) => this.setState({ captchaUrl: captchaPath + res.body.url }));
  };

  goBack = () => {
    this.updateCaptcha();
    this.setState({ initialValues: null, isAuthorized: false });
    window.user = null;
  };

  goToMain = () =>
    this.setState({
      isAuthorized: true,
      hasErrors: false,
      errorMessage: <FormattedMessage {...messages.unknownError} />,
    });

  componentWillUnmount() {
    this.setState({ draftId: undefined });
  }

  renderToast(msg) {
    toast(msg, {
      backgroundColor: '#f2dede',
      color: '#a94442',
    });
  }

  executeScrollToForm = () => {
    this.scrollToForm.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  render() {
    const RegisteredForm = this.form;
    const PreliminaryForm = this.preliminaryForm;
    const { formConfig, authorityData, isPersecution, isNormalForm } = this.props;
    const { loading, done, hasErrors, result, smsChecking, smsCheckingDone, isAuthorized, initialValues, captchaUrl } =
      this.state;

    return (
      <div className="over-bottom" style={{ position: 'relative', borderTop: 'none' }}>
        {loading ? <Spinner /> : null}
        {!done || hasErrors ? (
          <span>
            {isAuthorized ? (
              <RegisteredForm
                onSubmit={this.handleSubmit}
                scrollTo={this.scrollToForm}
                formConfig={formConfig}
                initialValues={initialValues}
                action={this.state.action}
                goBack={this.goBack}
                isPersecution={isPersecution}
                isNormalForm={isNormalForm}
                isJuridicalChecked={this.state.isJuridicalChecked}
                draftId={this.state.draftId}
                sendDraft={this.sendDraft}
              />
            ) : (
              <PreliminaryForm
                onSubmit={this.handleSubmitPreliminaryForm}
                goToMain={this.goToMain}
                updateCaptcha={this.updateCaptcha}
                captchaUrl={captchaUrl}
              />
            )}
          </span>
        ) : (
          <SubmittedView authorityData={authorityData} requestData={result} />
        )}
        {smsChecking && (
          <SmsForm
            handleSmsCheck={this.handleSmsSubmit}
            show={this.state.showSmsModal}
            onHide={() => this.setState({ showSmsModal: false })}
            done={smsCheckingDone}
            draftId={this.state.draftId}
          />
        )}
        <ToastContainer delay={5000} position="top-right" />
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({ appState: makeSelectData() });

export default connect(mapStateToProps)(MainFormManager);



// WEBPACK FOOTER //
// ./src/application-form/form-managers/main-form.js